import ace from 'ace/ace';

import { DARK_THEME } from 'cio/utils/syntax-highlighting';

let {
  bgPrimary,
  bgSecondary,
  bgIndents,
  bgHighlight,

  text01,
  text02,
  text03,

  purple,
  teal,
  yellow,
  blue,
  raspberry,
  clementine,

  // greenBg,
  // greenFg,

  // redBg,
  // redFg,
} = DARK_THEME;

// Defines a custom theme with our brand colors using Ace's configuration syntax.
ace.define('ace/theme/cio-dark', ['require', 'exports', 'module', 'ace/lib/dom'], function (require, exports) {
  exports.isDark = true;
  exports.cssClass = 'ace-cio-dark';
  exports.cssText = `
    .ace-cio-dark .ace_gutter {
      background-color: ${bgSecondary};
      color: ${text03};
    }

    .ace-cio-dark.ace_editor {
      background-color: ${bgPrimary};
      border-radius: 3px;
      color: ${text01};
    }

    .ace-cio-dark .ace_selected-word,
    .ace-cio-dark .ace_selection {
      background-color: ${bgHighlight};
    }

    .ace-cio-dark .ace_constant {
      color: ${clementine};
    }

    .ace-cio-dark .ace_keyword.ace_operator {
      color: ${text01};
    }

    .ace-cio-dark .ace_keyword {
      color: ${raspberry};
    }

    .ace-cio-dark .ace_attribute-name {
      color: ${text01};
    }

    .ace-cio-dark .ace_xml.ace_attribute-name {
      color: ${raspberry};
    }

    .ace-cio-dark .ace_string {
      color: ${teal};
    }

    .ace-cio-dark .ace_numeric {
      color: ${blue};
    }

    .ace-cio-dark .ace_boolean {
      color: ${yellow};
    }

    .ace-cio-dark .ace_comment {
      color: ${text03};
    }

    .ace-cio-dark .ace_name {
      color: ${purple};
    }

    .ace-cio-dark .ace_type {
      color: ${teal};
      font-weight: 500;
    }

    .ace-cio-dark .ace_storage.ace_type {
      color: ${raspberry};
      font-weight: 500;
    }

    .ace-cio-dark.ace_autocomplete {
      background-color: ${bgSecondary};
      border-color: transparent;
    }

    .ace-cio-dark.ace_autocomplete .ace_completion-highlight {
      color: ${purple};
    }

    .ace-cio-dark.ace_autocomplete .ace_marker-layer .ace_active-line {
      background-color: ${bgSecondary};
    }

    .ace-cio-dark.ace_autocomplete .ace_line.ace_selected {
      background-color: ${bgSecondary};
    }

    .ace-cio-dark.ace_autocomplete .ace_rightAlignedText {
      color: ${text02};
    }

    .ace-cio-dark .ace_tag-name {
      color: ${yellow};
    }

    .ace-cio-dark .ace_indent-guide {
      box-shadow: inset -1px 0 0 0 ${bgIndents};
    }
  `;

  let dom = ace.require('ace/lib/dom');
  dom.importCssString(exports.cssText, exports.cssClass);
});

(function () {
  window.require(['ace/theme/cio-dark'], function (m) {
    if (typeof module === 'object' && typeof exports === 'object' && module) {
      module.exports = m;
    }
  });
})();
